"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPos = void 0;
var immutable_1 = require("../../immutable");
exports.IPos = (0, immutable_1.IRecord)({ x: 0, y: 0 });
